module.exports = __webpack_public_path__ + "media/src/application/media/rooms/Sport3-3c0a6166421033d599f137cd0e4c2dcd.jpg";